import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

export const config = () => {
  library.add(fas);

  // Kicks off the process of finding <i> tags and replacing with <svg>
  dom.watch();
}
